// middleware/api.js
import { refreshLogin, receiveLogout } from '../actions/actions';
import JWT from '../modules/getjwtdata';

import server from '../config';

function callApi(endpoint, method, body = null, authenticated, type = 'text', dispatch) {
  let remember = false;
  let token = localStorage.getItem('token');

  if (token) {
    remember = true;
  } else {
    token = sessionStorage.getItem('token');
  }

  const accept = (type === 'text') ? 'application/json' : 'application/pdf';

  const config = {
    method,
    headers: {
      Accept: accept,
      'Content-Type': 'application/json',
    },
  };

  if (authenticated) {
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      dispatch(receiveLogout());
    }
  }

  if (body) {
    config.body = JSON.stringify(body);
  }

  return fetch(server + endpoint, config)
    .then((response) => {
      if (type === 'blob') {
        return response.blob()
          .then(payload => ({
            payload,
            response,
          }));
      }
      // text() reads a Response stream to completion as text
      return response.text()
        .then(payload => ({
          payload,
          response,
        }));
    })
    .then(({
      payload,
      response,
    }) => {
      console.log(payload);
      if (authenticated) {
        if (response.headers.get('Authorization') === null) {
          dispatch(receiveLogout());
          return Promise.reject('No valid token refresh');
        }

        const jwtToken = response.headers.get('Authorization')
          .replace('Bearer ', '');
        const validToken = JWT.verify(jwtToken);
        if (validToken) {
          if (remember) {
            localStorage.setItem('token', jwtToken);
          } else {
            sessionStorage.setItem('token', jwtToken);
          }

          dispatch(refreshLogin(jwtToken));
        } else {
          dispatch(receiveLogout());
          return Promise.reject('No valid token refresh');
        }
      }
      console.log(response);
      // Sometimes we might get an authorized response from unauthorized requests -
      // these are very special cases like registration or subscription. But it
      // makes live easier to still store the token from these responses.
      if (response.headers.get('Authorization') !== null) {
        const jwtToken = response.headers.get('Authorization')
          .replace('Bearer ', '');
        const validToken = JWT.verify(jwtToken);
        if (validToken) {
          if (remember) {
            localStorage.setItem('token', jwtToken);
          } else {
            sessionStorage.setItem('token', jwtToken);
          }

          dispatch(refreshLogin(jwtToken));
        }
      }

      if (!response.ok) {
        console.log('Rejectin promise');
        console.log(JSON.parse(payload));
        return Promise.reject(JSON.parse(payload));
      }

      if (type === 'text') {
        const truePayload = JSON.parse(payload);
        if (typeof truePayload.data === 'object') {
          return truePayload.data;
        }
        return truePayload;
      }
      return payload;
    })
    .catch(err => Promise.reject(err) );
}

export const CALL_API = 'Call API';

export default store => next => (action) => {
  const callAPI = action[CALL_API];

  // So the middleware doesn't get applied to every single action
  if (typeof callAPI === 'undefined') {
    return next(action);
  }

  const {
    endpoint,
    method,
    body,
    type,
    types,
    authenticated,
  } = callAPI;

  const [requestType, successType, errorType] = types;
  store.dispatch({
    type: requestType,
  });

  return callApi(endpoint, method, body, authenticated, type, store.dispatch, requestType)
    .then(
      response =>
      next({
        response,
        authenticated,
        type: successType,
      }),
      error => next({
        errors: error.errors,
        type: errorType,
      }),
    );
};



// WEBPACK FOOTER //
// ./src/middleware/api.js